import authReducer from "./auth/reducer";
import masterFormsReducer from "./masterForms/reducer";
import commonReducer from "./common/reducer";
import usersReducer from "./users/reducer";
import masterReducer from "./master/reducer";
import ticketsReducer from "./tickets/reducer";
import candidateReducer from "./candidate/reducer";
import courseReducer from "./course/reducer";
import venueReducer from "./venue/reducers";
import rollNumberReducer from "./rollNumber/reducers";
import forcePushAllocationReducer from "./forcePushAllocation/reducer";
import courseExamAndBatchReducer from "./courseExamAndBatch/reducer";
import customerReducer from "./customer/reducer";
import scorecardReducer from "./scorecard/reducer";
import bulkUploadReducer from "./bulkUpload/reducer";
import objectionTrackerReducer from "./objectionTracker/reducers";
import generateAdmitcardReducer from "./admitcardgeneration/reducer";
import eligibilityCriteriaReducer from "./eligibilityCriteria/reducers";
import AuditlogsReducer from "./auditlogs/reducer";
import capReducer from "./capRegistration/reducers";
import capVerifierReducer from "./capVerifier/reducers";

const reducers = {
    authReducer,
    masterFormsReducer,
    commonReducer,
    usersReducer,
    masterReducer,
    ticketsReducer,
    candidateReducer,
    courseReducer,
    venueReducer,
    rollNumberReducer,
    forcePushAllocationReducer,
    courseExamAndBatchReducer,
    customerReducer,
    scorecardReducer,
    bulkUploadReducer,
    objectionTrackerReducer,
    eligibilityCriteriaReducer,
    generateAdmitcardReducer,
    AuditlogsReducer,
    capReducer,
    capVerifierReducer
};

export default reducers;